import React from 'react'
import { WhenModelValue } from '@morningtrain/react-resources'

export default function WhenOrderIsPending ({ children, negate = false }) {
  return (
    <WhenModelValue name='status' condition={s => s === 'pending'} negate={negate}>
      {children}
    </WhenModelValue>
  )
}
